import { usePrivacy } from "#contexts/PrivacyContext"
import { cn } from "#lib/utils"
import { ReactNode } from "react"

interface PrivacyBlurProps {
  children: ReactNode
  className?: string
}

export function PrivacyBlur({ children, className }: PrivacyBlurProps) {
  const { isBlurred } = usePrivacy()

  return (
    <span
      className={cn("transition-all duration-200", isBlurred && "blur-sm select-none", className)}
    >
      {children}
    </span>
  )
}
